import { useMemoizedContentGetter } from 'utils/contentful'
import Section from 'components/Section'
import { memo } from 'react'
import { Typography, MediaImageStandard } from '@/components/Contentful'

function PersonCard({ item }) {
  const { title, subTitle, image } = item || {}
  return (
    <div className="flex flex-col rounded-[16px] bg-neutral-25">
      <div className="relative w-full aspect-3/4 rounded-[16px] rounded-b-none overflow-hidden max-h-[336px]">
        {image && (
          <MediaImageStandard
            content={{ url: image }}
            layout="fill"
            objectFit="cover"
            fillRelativeWrapper={false}
            className="object-top"
            alt={title}
          />
        )}
      </div>
      <div className="p-4 md:p-8">
        {title && (
          <p className="font-bold labelMd md:displaySm leading-[120%] text-content-primary m-0 mb-0 md:mb-2">
            {title}
          </p>
        )}
        {subTitle && (
          <p className="labelMd md:bodyLg text-content-secondary leading-[120%] m-0">{subTitle}</p>
        )}
      </div>
    </div>
  )
}

const PicturesGridModule = memo(function PicturesGridModule({ config }) {
  const { title, subTitle, items } = config || {}
  return (
    <Section
      disableGutters={true}
      data-testid="grid-section"
      className="py-12 sm:px-5 lg:py-16 lg:px-0"
      childContainerClassName="px-5 sm:px-8"
    >
      <div className="grid grid-cols-4 gap-x-8 gap-y-0 breakpointMd:grid-cols-6 breakpointLg:grid-cols-12 breakpointLg:gap-x-8 breakpointLg:gap-y-0 breakpointXl:grid-cols-12 breakpointXl:gap-x-8 breakpointXl:gap-y-0">
        <div className="col-span-4 breakpointMd:col-span-6 breakpointLg:col-span-12 breakpointXl:col-span-12 mb-8 breakpointMd:mb-12">
          {title && (
            <Typography
              content={title}
              variant="headingLg"
              className="headingLg font-bold md:text-[52px]! m-auto leading-[120%]! text-left lg:text-center pb-4"
              data-testid="pictures-grid-title"
              component="h2"
            />
          )}
          {subTitle && (
            <Typography
              content={subTitle}
              variant="bodySm"
              className="labelMd lg:displaySm font-light! text-left md:text-center"
              data-testid="pictures-grid-subtitle"
              component="h3"
            />
          )}
        </div>

        <div className="col-span-4 breakpointMd:col-span-6 breakpointLg:col-span-12 breakpointXl:col-span-12">
          <div className="grid grid-cols-2 breakpointLg:grid-cols-3 gap-x-4 gap-y-8 md:gap-x-6 lg:gap-x-8">
            {Array.isArray(items) && items.map((item, i) => <PersonCard key={i} item={item} />)}
          </div>
        </div>
      </div>
    </Section>
  )
})

function PicturesGrid({ content }) {
  const { config } = useMemoizedContentGetter(content, ['config'])
  return <PicturesGridModule config={config?.jsonContent || {}} />
}

export { PicturesGrid, PicturesGridModule }
export default PicturesGrid
